import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from 'react-router-dom';

import config from './utils/config';

Sentry.init({
    dsn: config.sentryDsn,
    environment: getEnvironment(),
    enabled: getEnvironment() !== 'localhost',
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        'localhost',
        /^https:\/\/go\.cloudcharge\.tech/,
        /^https:\/\/(demo|dev|staging)\.go\.cloudcharge\.tech/,
    ],

    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

function getEnvironment() {
    const hostname = window.location.hostname;

    const [env] = hostname.split('.');
    if (env === 'go') {
        return 'production';
    }

    return env;
}
